// ModifierCustomChoices — part of the product option modal (ProductOptionView).
import { isSoldOutByOnlineInventory } from '@core/utils/productOptions';
import { getModifierCustomGroups } from '../normalize';
import OptionPriceDelta from './OptionPriceDelta.jsx';

export default function ModifierCustomChoices({
  modifierOption,
  modifierSelection,
  onSelectModifierAlternate,
  onSelectModifierExtra,
  t,
}) {
  const modifierCustom = modifierOption ? getModifierCustomGroups(modifierOption) : null;
  if (!modifierCustom) return null;

  const hasSelectedAlternate = Boolean(modifierSelection?.alternate);
  const hasSelectedExtra = Object.values(modifierSelection?.extras || {}).some(Boolean);
  const hasAlternates = modifierCustom.alternateModifiers.length > 0;
  const hasExtras = modifierCustom.extraGroups.some((group) => group.items.length > 0);
  if (!hasAlternates && !hasExtras) return null;

  return (
    <div className="po-children">
      {hasAlternates ? (
        <div className={`po-child-block ${hasSelectedExtra ? 'is-disabled' : ''}`}>
          <div className="po-child-label">
            <span className="po-child-label-title">{t('swapLabel', 'Swap for')}</span>
            <span className="po-child-label-hint">
              {t('optionalPickOne', 'optional · pick one')}
            </span>
          </div>
          <div className="po-chip-row">
            {modifierCustom.alternateModifiers.map((option) => {
              const selected = modifierSelection?.alternate?.id === option.id;
              const soldOut = isSoldOutByOnlineInventory(option);
              return (
                <button
                  key={option.id}
                  type="button"
                  aria-pressed={selected}
                  disabled={(hasSelectedExtra && !selected) || soldOut}
                  onClick={() => !soldOut && onSelectModifierAlternate(option)}
                  className={`po-chip ${selected ? 'is-selected' : ''} ${soldOut ? 'is-disabled' : ''}`}
                >
                  <span>{option.name}</span>
                  {soldOut ? (
                    <span className="po-chip-delta">{t('outOfStock', 'Out of stock')}</span>
                  ) : option.priceDelta ? (
                    <OptionPriceDelta amount={option.priceDelta} className="po-chip-delta" />
                  ) : null}
                </button>
              );
            })}
          </div>
        </div>
      ) : null}

      {modifierCustom.extraGroups.map((group) =>
        group.items.length ? (
          <div
            key={group.id}
            className={`po-child-block ${hasSelectedAlternate ? 'is-disabled' : ''}`}
          >
            <div className="po-child-label">
              <span className="po-child-label-title">
                {group.name || t('extrasLabel', 'Extras')}
              </span>
              <span className="po-child-label-hint">{t('optionalAddOn', 'optional add-on')}</span>
            </div>
            <div className="po-chip-row">
              {group.items.map((item) => {
                const selected = modifierSelection?.extras?.[group.id]?.id === item.id;
                const soldOut = isSoldOutByOnlineInventory(item);
                return (
                  <button
                    key={item.id}
                    type="button"
                    aria-pressed={selected}
                    disabled={hasSelectedAlternate && !selected}
                    onClick={() => onSelectModifierExtra(group, item)}
                    className={`po-chip ${selected ? 'is-selected is-extra' : ''}`}
                  >
                    <span>{item.name}</span>
                    {soldOut ? (
                      <span className="po-chip-delta">{t('outOfStock', 'Out of stock')}</span>
                    ) : item.price ? (
                      <OptionPriceDelta amount={item.price} className="po-chip-delta" />
                    ) : null}
                  </button>
                );
              })}
            </div>
          </div>
        ) : null,
      )}
    </div>
  );
}
